import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import ChatWidget from "../components/site/ChatWidget";
import QuoteEstimator from "../components/site/QuoteEstimator";

export default function QuotePage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <section className="pt-32 pb-24 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.22em] text-primary mb-3">
            AI Instant Quote
          </div>
          <h1 className="font-display text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Your move, priced in <em className="text-primary not-italic">seconds.</em>
          </h1>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            Fill the form. Our AI factors in your route, home size and floors to produce a realistic price band. A human ops manager confirms the final quote on a call.
          </p>
        </div>
        <QuoteEstimator />
      </section>
      <Footer />
      <ChatWidget />
    </div>
  );
}
